/**
 * UI-6b Task 9 — ConversationVolume config editor.
 *
 * Dropdown for time-window in days. Common report-builder presets only.
 */
import type { JSX } from 'react'
import { Dropdown } from 'primereact/dropdown'
import type { ConversationVolumeConfig } from './Renderer.js'

interface Props {
  config: ConversationVolumeConfig
  onChange: (next: ConversationVolumeConfig) => void
}

const OPTIONS: Array<{ label: string; value: number }> = [
  { label: 'Last 1 day', value: 1 },
  { label: 'Last 7 days', value: 7 },
  { label: 'Last 30 days', value: 30 },
]

export function ConversationVolumeConfigEditor({
  config,
  onChange,
}: Props): JSX.Element {
  return (
    <div className="flex flex-col gap-3" data-testid="conversation-volume-config-editor">
      <label className="flex flex-col gap-1 text-sm">
        <span className="font-medium">Time window</span>
        <Dropdown
          value={config.days}
          options={OPTIONS}
          onChange={(e): void => onChange({ ...config, days: e.value as number })}
          ariaLabel="Time window in days"
          inputId="conversation-volume-days"
        />
      </label>
    </div>
  )
}
